import { useEffect } from 'react'
import type { JsonLd } from '../lib/schema-org'

const GLOBAL_ID = 'bnkr-schema-global'
const PAGE_ID = 'bnkr-schema-page'

function upsertScript(id: string, data: JsonLd | null) {
  const sel = `script#${id}`
  let el = document.querySelector(sel) as HTMLScriptElement | null
  if (!data) {
    el?.remove()
    return
  }
  const json = JSON.stringify(data)
  if (!el) {
    el = document.createElement('script')
    el.id = id
    el.type = 'application/ld+json'
    document.head.appendChild(el)
  }
  el.textContent = json
}

/** Site-wide Organization + WebSite graph (Layout). */
export function useGlobalSchema(graph: JsonLd | null) {
  useEffect(() => {
    upsertScript(GLOBAL_ID, graph)
    return () => upsertScript(GLOBAL_ID, null)
  }, [graph])
}

/** Per-route structured data (@graph). */
export function useSchemaOrg(graph: JsonLd | null) {
  const key = graph ? JSON.stringify(graph) : null
  useEffect(() => {
    upsertScript(PAGE_ID, graph)
    return () => upsertScript(PAGE_ID, null)
  }, [key, graph])
}
